(function() {
    'use strict';
    angular
        .module('nasracApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        var roles = ['Administrators', 'Billing Administrator', 'Billing User'];
        var fullAccessRoles = ['Administrators', 'Billing Administrator'];
        $stateProvider.state('astb', {
            abstract: true,
            parent: 'app'
        }).state('astbmso-main', {
            abstract: true,
            parent: 'astb',
            url: '/astbmso-main',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.mso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/astb.html',
                    controller: 'ASTBMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('astbmso-main.mso', {
            url:         '/mso',
            templateUrl: 'app/astb/mso/msos.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.mso.home.title'
            },
            controller: 'ASTBMsoController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('astbmso-main.mso.new', {
            parent: 'astbmso-main.mso',
            url: '/new',
            data: {
                authorities: fullAccessRoles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'ASTBMsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                msoName: null,
                                msoAddress: null,
                                msoNoMotcode: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.mso', null, { reload: 'astbmso-main.mso' });
                }, function() {
                    $state.go('astbmso-main.mso');
                });
            }]
        }).state('astbmso-main.mso.edit', {
            parent: 'astbmso-main.mso',
            url: '/{id}/edit',
            data: {
                authorities: fullAccessRoles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'ASTBMsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.mso', null, { reload: 'astbmso-main.mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('astbmso-main.mso.delete', {
            parent: 'astbmso-main.mso',
            url: '/{id}/delete',
            data: {
                authorities: fullAccessRoles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-delete-dialog.html',
                    controller: 'ASTBMsoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.mso', null, { reload: 'astbmso-main.mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('astbmso-main.office', {
            parent: 'astbmso-main',
            url: '/office',
            templateUrl: 'app/astb/office/offices.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.office.home.title'
            },
            controller: 'ASTBOfficeController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('astbmso-main.office-detail', {
                parent: 'astbmso-main.office',
                url: '/office/{id}',
                data: {
                    authorities: fullAccessRoles,
                    pageTitle: 'nasracApp.office.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/astb/office/office-detail.html',
                        controller: 'ASTBOfficeDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('office');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Office', function($stateParams, Office) {
                        return Office.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'office',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('astbmso-main.office-detail.edit', {
                parent: 'astbmso-main.office-detail',
                url: '/detail/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-dialog.html',
                        controller: 'ASTBOfficeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Office', function(Office) {
                                return Office.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.office.new', {
                parent: 'astbmso-main.office',
                url: '/new',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-dialog.html',
                        controller: 'ASTBOfficeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    officeName: null,
                                    officeAddress: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.office', null, { reload: 'astbmso-main.office' });
                    }, function() {
                        $state.go('astbmso-main.office');
                    });
                }]
            })
            .state('astbmso-main.office.edit', {
                parent: 'astbmso-main.office',
                url: '/{id}/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-dialog.html',
                        controller: 'ASTBOfficeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Office', function(Office) {
                                return Office.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.office', null, { reload: 'astbmso-main.office' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.office.delete', {
                parent: 'astbmso-main.office',
                url: '/{id}/delete',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-delete-dialog.html',
                        controller: 'ASTBOfficeDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Office', function(Office) {
                                return Office.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.office', null, { reload: 'astbmso-main.office' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }).state('astbmso-main.headend', {
            parent: 'astbmso-main',
            url: '/headend',
            templateUrl: 'app/astb/headend/headends.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.headend.home.title'
            },
            controller: 'ASTBHeadendController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('headend');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('astbmso-main.headend-detail', {
                parent: 'astbmso-main.headend',
                url: '/headend/{id}',
                data: {
                    authorities: fullAccessRoles,
                    pageTitle: 'nasracApp.headend.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/astb/headend/headend-detail.html',
                        controller: 'ASTBHeadendDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('headend');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Headend', function($stateParams, Headend) {
                        return Headend.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'headend',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('astbmso-main.headend-detail.edit', {
                parent: 'astbmso-main.headend-detail',
                url: '/detail/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-dialog.html',
                        controller: 'ASTBHeadendDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Headend', function(Headend) {
                                return Headend.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.headend.new', {
                parent: 'astbmso-main.headend',
                url: '/new',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-dialog.html',
                        controller: 'ASTBHeadendDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    bsiCode: null,
                                    headendType: null,
                                    headendName: null,
                                    headendAddress: null,
                                    headendCity: null,
                                    headendState: null,
                                    headendZip: null,
                                    headendContactName: null,
                                    headendPhoneNumber: null,
                                    downlinkLocation: null,
                                    boxFeeMot: null,
                                    boxFeeNonMot: null,
                                    dtaFee: null,
                                    minimumFee: null,
                                    usingNonMotCode: false,
                                    nctcMember: false,
                                    nctcMemberId: '',
                                    nctcSystemId: '',
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                    }, function() {
                        $state.go('astbmso-main.headend');
                    });
                }]
            })
            .state('astbmso-main.headend.edit', {
                parent: 'astbmso-main.headend',
                url: '/{id}/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-dialog.html',
                        controller: 'ASTBHeadendDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Headend', function(Headend) {
                                return Headend.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.headend.delete', {
                parent: 'astbmso-main.headend',
                url: '/{id}/delete',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-delete-dialog.html',
                        controller: 'ASTBHeadendDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Headend', function(Headend) {
                                return Headend.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.billing-current-reports', {
                url:         '/billing-current-reports',
                templateUrl: 'app/astb/templates/billing-current-reports.html',
                data: {
                    authorities: roles,
                },
                controller: 'ASTBMsoController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('mso');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
        /*  }).state('astbmso-main.billing-current-reports', {
         parent: 'astb',
         url: '/billing-current-reports',
         views: {
         'content@': {
         templateUrl: 'app/astb/templates/billing-current-reports.html',
         controller: 'AstbBillingController',
         controllerAs: 'AstbBillingCtrl'
         }
         }
         })*/
    }
})();
